var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_2826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9971 50C24.7487 50 24.5003 50 24.2519 49.9884L29.3588 35.9503H36.3894C37.6256 35.9503 38.9775 35.0029 39.3992 33.8417L44.9393 18.6193C45.8463 16.1294 44.4194 14.0901 41.7678 14.0901H32.0162L23.8302 36.58L19.1912 49.3299C8.18602 46.7013 0 36.8053 0 24.9971C0 13.1889 7.72386 3.87059 18.2496 0.924321L13.4604 14.0843L5.49971 35.9503H10.7972L17.5679 17.3715H21.5482L14.7776 35.9503H20.0751L26.3836 18.6193C27.2906 16.1294 25.8637 14.0901 23.212 14.0901H18.7579L23.8764 0.028885C24.2519 0.011554 24.6216 0 24.9971 0C38.8042 0 49.9942 11.1901 49.9942 24.9971C49.9942 38.8042 38.8042 49.9942 24.9971 49.9942V50ZM40.1271 17.3541H36.1467L30.5719 32.6516H34.5523L40.1271 17.3541Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_2826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHard2);
export default __webpack_public_path__ + "static/media/hard2.22e8a1e094f864cddcde19a26fefb581.svg";
export { ForwardRef as ReactComponent };